import React, { useState, useEffect, Component } from 'react'
import styled from 'styled-components'
import cn from 'classnames'
import { isNewTabMenu, openInNewTab } from '../../utils'
import Iconfont from '../Iconfont'

const SideMenu = styled.ul`
  background: #fff;
  list-style: none;
  margin: 0;
  padding: 30px 0 20px;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .isInIframe & {
    display: none;
  }

  & > li {
    position: relative;
    cursor: pointer;
    line-height: 38px;
    font-size: 14px;
    color: #17233d;
    letter-spacing: 0;

    &.group-menu-item {
      & > span {
        opacity: 0.4;
      }
    }

    &.active {
      &:before {
        position: absolute;
        content: '';
        left: 0;
        top: 0;
        width: 3px;
        height: 100%;
        background: #126bfb;
      }

      span {
        background: rgba(18, 107, 251, 0.1);
        color: #126bfb;
        opacity: 1;
      }
    }

    & > span {
      display: inline-block;
      width: 100%;
      color: #17233d;
      padding-left: 20px;

      &:hover {
        color: #323232;
        background: #f5f5f5;
      }

      & > .tnt-icon {
        margin-right: 7px;
      }
    }
  }
`

const SubMenu = styled.ul`
  background: #fff;
  list-style: none;
  font-size: 14px;
  color: #17233d;
  margin: 10px 0 0;
  padding: 0;
  li {
    position: relative;
    line-height: 38px;
    cursor: pointer;
    padding-left: 20px;
    & > a {
      color: #17233d;
      & > span {
        padding-left: 10px;
      }
    }
    &.active {
      background: #eaedf8;
      &:before {
        position: absolute;
        left: 0;
        top: 0;
        content: '';
        width: 4px;
        height: 100%;
        background-color: #4c79ff;
      }
    }
  }
`

export default (props) => {
  const {
    language,
    menus = [],
    formatMenuPath,
    selectedKey,
    onBeforeChange,
    onChange,
    onSelect,
  } = props
  const [activeMenu, setActiveMenu] = useState(selectedKey)
  const defaultBeforeChange = ({ data }) => !isNewTabMenu(data)
  const defaultSelect = ({ data }) => {
    const { path } = data || {}
    const formatPath = formatMenuPath || ((path) => path)

    if (isNewTabMenu(data)) {
      openInNewTab(formatPath(data?.path, data))
      return
    }

    const routerPrefix = window.location.pathname.match(/(^\/[^\/]+)/i)?.[1]

    if (window.location.pathname.startsWith(routerPrefix)) {
      const forwardPath = formatPath(path, data)
      changeRouter
        ? changeRouter(forwardPath, data)
        : window.history.pushState(data, data?.name, forwardPath)
    } else {
      window.location.href = formatPath(path, data)
    }
  }
  const selectMenu = (param = {}) => {
    const finalBeforeChange = onBeforeChange || defaultBeforeChange
    const finalSelect = onSelect || defaultSelect

    if (param.key !== activeMenu) {
      if (finalBeforeChange(param, activeMenu)) {
        setActiveMenu(param.key)
        onChange && onChange(param)
      }
    }

    finalSelect(param)
  }

  const MenuItem = ({ item }) => {
    const { code, groupName, enName, children = [] } = item
    const SubMenuItem = ({ menu }) => {
      const { code, menuName, enName, icon } = menu

      return (
        <li
          key={code}
          onClick={(evt) => selectMenu({ key: code, data: menu, domEvent: evt })}
          className={cn({ active: code === activeMenu })}
        >
          <span>
            {typeof (icon || '') === 'string' ? <Iconfont type={icon} /> : icon}
            {
              {
                cn: menuName,
                en: enName,
              }[language]
            }
          </span>
        </li>
      )
    }

    if (groupName && children.length) {
      return (
        <li key={code} className="group-menu-item">
          <span>
            {icon instanceof Component ? icon : <Iconfont type={icon} />}
            {
              {
                cn: groupName,
                en: enName,
              }[language]
            }
          </span>
          <SubMenu>
            {children.map((subItem) => (
              <SubMenuItem menu={subItem} key={subItem?.code} />
            ))}
          </SubMenu>
        </li>
      )
    }

    return <SubMenuItem menu={item} />
  }

  useEffect(() => {
    setActiveMenu(selectedKey)
  }, [selectedKey])

  return (
    <SideMenu className="tnt-compact-sidemenu">
      {menus.map((menu) => (
        <MenuItem item={menu} key={menu.code} />
      ))}
    </SideMenu>
  )
}
